import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useBusinessCard } from './BusinessCard';
import { makeStyles } from '@material-ui/styles';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const useStyles = makeStyles(theme => ({
  img: {
    height: 100,
  },
  a: {
    textDecoration: 'none',
  },
}));
const Coupon = () => {
  const styles = useStyles();
  const [banner, setBanner] = useState();
  const [link, setLink] = useState();
  const {
    organizationId,
    dimensions: { vw },
  } = useBusinessCard();
  useEffect(() => {
    if (organizationId) {
      firebase
        .firestore()
        .collection('organizations')
        .doc(organizationId)
        .get()
        .then(doc => {
          if (doc.exists) {
            setLink(doc.data()?.coupon?.link);
            const bannerRef = doc.data()?.coupon?.banner;
            if (bannerRef)
              firebase
                .storage()
                .ref(bannerRef)
                .getDownloadURL()
                .then(url => {
                  setBanner(url);
                });
          } else {
          }
        });
    }
  }, [organizationId]);

  if (!banner) {
    return null;
  }
  return (
    <Grid
      item
      xs={12}
      style={{
        marginBottom: vw(16),
        paddingRight: vw(8),
        paddingLeft: vw(8),
        paddingTop: 0,
        textAlign: 'center',
      }}
    >
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img src={banner} alt="coupon" className={styles.img} />
      </a>
    </Grid>
  );
};

export default Coupon;
